import React from "react";
import { useTranslation } from "react-i18next";

import { SocialChannel, SOCIAL_ICONS } from "../View";

import {
    Card,
    SectionHeader,
    CardTitle,
    ToggleContainer,
    ToggleLabel,
    Toggle,
    SocialItem,
    SocialIconBox,
    SocialInfo,
    SocialName,
    SocialUrlInput,
    SocialToggle,
} from "./styled";

type SocialNetworksCardProps = {
    mainColor: string;
    showSocialNetworks: boolean;
    onToggleShowSocialNetworks: () => void;
    socialChannels: SocialChannel[];
    onToggleSocial: (key: string) => void;
    onSocialUrlChange: (key: string, url: string) => void;
};

export function SocialNetworksCard({
    mainColor,
    showSocialNetworks,
    onToggleShowSocialNetworks,
    socialChannels,
    onToggleSocial,
    onSocialUrlChange,
}: SocialNetworksCardProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <Card data-testid="scan-to-misc-social-networks-card">
            <SectionHeader>
                <CardTitle>{t("Social networks")}</CardTitle>
                <ToggleContainer>
                    <ToggleLabel>{t("Show social networks")}</ToggleLabel>
                    <Toggle
                        data-testid="scan-to-misc-show-social-toggle"
                        isActive={showSocialNetworks}
                        mainColor={mainColor}
                        onClick={onToggleShowSocialNetworks}
                        aria-label={t("Show social networks")}
                    />
                </ToggleContainer>
            </SectionHeader>

            {socialChannels.map((channel) => (
                <SocialItem
                    key={channel.key}
                    data-testid={`scan-to-misc-social-item-${channel.key}`}
                >
                    <SocialIconBox
                        enabled={showSocialNetworks && channel.enabled}
                    >
                        <svg viewBox="0 0 24 24">
                            <path d={SOCIAL_ICONS[channel.key] || ""} />
                        </svg>
                    </SocialIconBox>
                    <SocialInfo>
                        <SocialName>{t(channel.label)}</SocialName>
                        <SocialUrlInput
                            data-testid={`scan-to-misc-social-url-input-${channel.key}`}
                            value={channel.url}
                            onChange={(e) =>
                                onSocialUrlChange(channel.key, e.target.value)
                            }
                            placeholder={t("Profile URL")}
                            disabled={!showSocialNetworks}
                        />
                    </SocialInfo>
                    <SocialToggle
                        data-testid={`scan-to-misc-social-toggle-${channel.key}`}
                        isActive={channel.enabled}
                        mainColor={mainColor}
                        onClick={() => onToggleSocial(channel.key)}
                    />
                </SocialItem>
            ))}
        </Card>
    );
}
